import api from 'api/api'
import { toast } from 'react-toastify'
import { urlPdfs } from 'constants/urls'
import { printPDFfromURL } from 'utils/pdf'

export const GET_PROFORMAS = '[PROFORMAS] GET PROFORMAS'
export const GET_PROFORMA_BY_ID = '[PROFORMAS] GET PROFORMA BY ID'
export const RESET_PROFORMA_BY_ID = '[PROFORMAS] RESET PROFORMA BY ID'
export const SAVE_PROFORMA = '[PROFORMAS] SAVE PROFORMA'
export const FINISH_PROFORMA_REGISTER = '[PROFORMAS] FINISH PROFORMA REGISTER'
export const VOID_PROFORMA = '[PROFORMAS] VOID PROFORMA'

export function getProformasAction(filters = { skipUserId: 0, startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/proformas/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_PROFORMAS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_PROFORMAS, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_PROFORMAS, error)
    }).finally(() => {
      dispatch({ type: GET_PROFORMAS, payload: { loading: false } })
    })
  }
}

export function getProformaByIdAction(proformaId) {
  const request = api.get(`/proforma/${proformaId}`)
  return (dispatch) => {
    dispatch({ type: GET_PROFORMA_BY_ID, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_PROFORMA_BY_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_PROFORMA_BY_ID, error)
    }).finally(() => {
      dispatch({ type: GET_PROFORMA_BY_ID, payload: { loading: false } })
    })
  }
}

export function saveProformaAction(data) {
  const request = api.post(`/proforma/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_PROFORMA, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_PROFORMA, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_PROFORMA, error)
    }).finally(() => {
      dispatch({ type: SAVE_PROFORMA, payload: { saving: false } })
    })
  }
}

export function finishProformaRegisterAction(proformaId) {
  const request = api.post(`/proforma/finish-register/${proformaId}`)
  return (dispatch) => {
    dispatch({ type: FINISH_PROFORMA_REGISTER, payload: { finishing: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: FINISH_PROFORMA_REGISTER, payload: { finished: true, data: response.data.data } })
      // printPDFfromURL(`${urlPdfs.proformaA4}/${proformaId}`)
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(FINISH_PROFORMA_REGISTER, error)
    }).finally(() => {
      dispatch({ type: FINISH_PROFORMA_REGISTER, payload: { finishing: false } })
    })
  }
}

export function voidProformaAction(proformaId) {
  const request = api.delete(`/proforma/void/${proformaId}`)
  return (dispatch) => {
    dispatch({ type: VOID_PROFORMA, payload: { voiding_id: proformaId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_PROFORMA, payload: { voided_id: proformaId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_PROFORMA, error)
    }).finally(() => {
      dispatch({ type: VOID_PROFORMA, payload: { voiding_id: proformaId } })
    })
  }
}

export function sendProformaToEmailAction({ proformaId, to }) {
  const request = api.post(`/proforma/send-proforma-to-email`, { proformaId, to })
  return () => {
    toast.info(`Enviando comprobante a ${to}...`, { toastId: 'sendProformaToEmail', autoClose: false })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message, { toastId: 'sendProformaToEmail' })
        return
      }
      toast.success(response.data.message, { toastId: 'sendProformaToEmail' })
    }).catch((error) => {
      toast.error(error.response?.data?.message ?? 'No se pudo enviar el comprobante', { toastId: 'sendProformaToEmail' })
      console.log(error)
    }).finally(() => {
      toast.update('sendProformaToEmail', { autoClose: 3000 })
    })
  }
}